var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_7842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.032 0.5H2.58047C1.60078 0.5 0.808594 1.27344 0.808594 2.22969V22.7656C0.808594 23.7219 1.60078 24.5 2.58047 24.5H23.032C24.0117 24.5 24.8086 23.7219 24.8086 22.7703V2.22969C24.8086 1.27344 24.0117 0.5 23.032 0.5ZM7.92891 20.9516H4.36641V9.49531H7.92891V20.9516ZM6.14766 7.93438C5.00391 7.93438 4.08047 7.01094 4.08047 5.87187C4.08047 4.73281 5.00391 3.80937 6.14766 3.80937C7.28672 3.80937 8.21016 4.73281 8.21016 5.87187C8.21016 7.00625 7.28672 7.93438 6.14766 7.93438ZM21.2602 20.9516H17.7023V15.3828C17.7023 14.0562 17.6789 12.3453 15.8508 12.3453C13.9992 12.3453 13.718 13.7937 13.718 15.2891V20.9516H10.1648V9.49531H13.5773V11.0609H13.6242C14.0977 10.1609 15.2602 9.20938 16.9898 9.20938C20.5945 9.20938 21.2602 11.5813 21.2602 14.6656V20.9516Z",
    fill: "#403B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_7842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.808594 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9f632bcb6c77258db7f3721d0edc936b.svg";
export { ForwardRef as ReactComponent };